export default {
  en: {
    snack: {
      generic_error: 'Something went wrong',
      favorite: {
        on: 'Successfully added to favorites',
        off: 'Successfully removed from favorites',
      },
      notifications: {
        on: 'Notifications enabled successfully',
        off: 'Notifications disabled successfully',
      },
    },
    confirm_dialog_msg: {
      default: 'Are you sure?',
    },
    actions: {
      favorite: {
        on: 'Remove from favorites',
        off: 'Add to favorites',
      },
      notifications: {
        on: 'Disable %{name} notifications',
        off: 'Enable %{name} notifications',
      },
      inappropriate_report: 'Report as inappropriate',
      tags: 'Tags',
      settings: 'Edit',
      leave_community: 'Leave community',
      leave_group: 'Leave group',
      admin: 'Admin',
      cancel: 'Cancel',
    },
    subsections: {
      stream: 'official',
      marketplace: 'marketplace',
      booking: 'booking',
      forum: 'forum',
    },
  },
};
